<template>
    <div class="hd-runtime-main pageBg" :style="{width: $pScreen.mainW, height: $pScreen.height + 'px'}">
        <div class="tipText">
            请确定以下信息：
        </div>
        <ul class="msgBox">
            <li v-for="(item,index) in list" :key="index">
                <div class="msgDesc">{{item.name}}</div>
                <div>{{item.value}}</div>
            </li>
        </ul>
        <div class="privateWrapper">
            <div @click="changeSelect" class="privateAgreen">
                <Icon type="text" :style="{fontSize:$pScreen.textS, marginRight: '5px'}" :icon="isSelect?'check-square':'square'" :class="isSelect?'selected':''"></Icon>
                <span style="margin-right: 10px;">我已阅读并同意</span>
            </div>
            <p style="color: blue;" @click="toPrivate">荣耀微信会员隐私声明</p>
        </div>
        <div class="activate" @click="activate">
            激活会员卡
        </div>
    </div>
</template>
<script>
    import wx from 'weixin-js-sdk';
    import privateText from "./privateText";
    import { Dialog } from 'vant';
    export default {
        components: {privateText},
        data(){
            return {
                urlParams: {
                    activateTicket: '',
                    openid: '',
                    cardId: '',
                    codeEncryptCode: '',
                },
                list: [],
                clickFlag: false,
                isSelect: true,
            }
        },
        created(){
            document.querySelector('html').style.fontSize = '10px';
            this.urlParams = Object.assign({}, this.$route.query);
            document.title = "激活会员卡";
            let self = this;
            self.$api.post({
                sc: "member2",
                url: "wechat/member/card/activatetempinfo/get",
                params: {activateTicket: self.urlParams.activate_ticket},
                success: r => {
                    console.log(r);
                    self.list = r.result || [];
                }
            })
        },
        methods: {
            changeSelect(){
                this.isSelect = !this.isSelect;
            },
            toPrivate(){
                this.$router.push({
                    name: "privateText",
                });
            },
            activate(){
                if(!this.isSelect){
                    this.$utils.tips.message('warning', '请勾选荣耀微信会员隐私声明！');
                    return false
                }
                let self = this;
                if(self.clickFlag){
                    return false;
                }
                self.clickFlag = true;
                self.$api.post({
                    sc: "member2",
                    url: "wechat/member/card/activate",
                    params: {
                        activateTicket: self.urlParams.activate_ticket,
                        openid: self.urlParams.openid,
                        cardId: self.urlParams.card_id,
                        codeEncryptCode: self.urlParams.encrypt_code,
                    },
                    success: r => {
                        console.log(r);
                        setTimeout(function(){
                            wx.closeWindow();
                        },1000);
                    },
                    failure:(err) => {
                        self.clickFlag = false;
                        Dialog({  message: "活动过于火爆，请稍后再试" })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .pageBg {
        background: #f2f2f2;
        margin: 0 auto;
        display: block;
        font-size: 1.4rem;
    }
    .tipText {
        padding: 30px 0 0 20px;
    }
    .msgBox {
        padding: 20px;
        background: #fff;
        border: 1px solid #eee;
        margin-top: 5px;
    }
    .msgBox li {
        line-height: 26px;
        display: flex;
    }
    .msgDesc {
        color: #bdbdbd;
        width: 70px;
    }
    ul,li {
        list-style: none;
    }
    .activate {
        width: calc(100% - 40px);
        margin: 20px 0 0 20px;
        background: #05bd03;
        height: 40px;
        line-height: 42px;
        text-align: center;
        color: #fff;
        border-radius: 4px;
    }
    .i-circle:before, .i-check-circle:before, .i-square:before, .i-check-square:before{
        content: " ";
    }
    .i-square, .i-check-square{
        width: 16px !important;
        height: 16px;
        background: url('../../../../static/runtime/images/magic/checkbox.png') no-repeat;
        background-size: 100%;
    }
    .i-check-square {
        background-image: url('../../../../static/runtime/images/magic/checkboxSelected2.png');
    }
    .privateWrapper {
        display: flex;
        align-items: center;
        margin-left: 20px;
        margin-top: 30px;
        font-size: 1.2rem;
    }
    .privateAgreen {
        display: flex;
        align-items: center;
    }
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/activateCard.vue